import * as u from './utils';

export default () => {
    const menus = Array.prototype.slice.call(document.querySelectorAll('.sticky-menu'));

    if (menus.length <= 1 || window.innerWidth <= 1024) {
        return;
    }

    // Convert menus to reversed array so we cna work with them easier
    const reverseMenus = menus.slice().reverse();

    // Remove default header styling so it cna run dynamically
    document.querySelector('.site-wrap').style.paddingTop = '0px';
    u.removeClass(document.querySelector('.header'), 'js-unloaded');

    // Setup spacing container to resize when the screen does
    const handleResize = () => {
        for (const el of menus) {
            el.style.height = 'auto';
            el.style.height = el.querySelector('.sticky-menu__menu').offsetHeight + 'px';
        }
    };
    handleResize();
    window.addEventListener('resize', handleResize);

    // Loop through menus and set the lowest one on screen to be sticky
    const handleScroll = () => {
        // Unset previous sticky menus
        u.removeClass(menus, 'is-sticky');
        u.removeClass(menus, 'was-sticky');

        // Work out what menu we need to set as sticky
        let stickyIndex = reverseMenus.length - 1;
        for (let i = 0; i < reverseMenus.length; i++) {
            let previousMenuHeight = 0;
            if (i < reverseMenus.length - 1) {
                previousMenuHeight = reverseMenus[i + 1].offsetHeight;
            }
            const offset = reverseMenus[i].offsetTop - window.pageYOffset - previousMenuHeight;

            if (offset < 0 && u.isElementVisible(reverseMenus[i])) {
                stickyIndex = i;
                break;
            }
        }
        u.addClass(reverseMenus[stickyIndex], 'is-sticky');

        // Reposition menus
        for (let i = 0; i < menus.length; i++) {
            const menu = menus[i];
            const fixedElement = menu.querySelector('.sticky-menu__menu');
            fixedElement.style.top = '0';

            if (u.hasClass(menu, 'is-sticky')) {
                // push down based on previous menu
                const previousMenu = menus[i - 1];
                if (previousMenu) {
                    const offset = Math.max(0, menu.offsetTop - window.pageYOffset);

                    fixedElement.style.top = offset + 'px';
                }
                break;
            } else if (i < menus.length) {
                // push up based on next menu
                const nextMenu = menus[i + 1];
                const offset = nextMenu.offsetTop - window.pageYOffset - menu.offsetHeight;

                fixedElement.style.top = offset + 'px';
            }

            u.addClass(menu, 'was-sticky');
        }
    };
    document.addEventListener('scroll', handleScroll);

    handleScroll();
};
